import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { PortalLayout } from './components/PortalLayout';
import { Login } from './pages/Login';
import { AuthConfirm } from './pages/AuthConfirm';
import { Overview } from './pages/Overview';
import { Difot } from './pages/Difot';
import { FailedDeliveries } from './pages/FailedDeliveries';
import { DriverPerformance } from './pages/DriverPerformance';
import { Timing } from './pages/Timing';
import { MilestoneDistance } from './pages/MilestoneDistance';
import { CustomerFeedback } from './pages/CustomerFeedback';
import { DpdHandoffs } from './pages/DpdHandoffs';
import { DeliveryCost } from './pages/DeliveryCost';
import { Users } from './pages/Users';
import { InviteUser } from './pages/InviteUser';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/confirm" element={<AuthConfirm />} />

      <Route
        element={
          <ProtectedRoute>
            <PortalLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/reporting/overview" replace />} />
        <Route path="/reporting" element={<Navigate to="/reporting/overview" replace />} />
        <Route path="/reporting/overview" element={<Overview />} />
        <Route path="/reporting/difot" element={<Difot />} />
        <Route path="/reporting/failed" element={<FailedDeliveries />} />
        <Route path="/reporting/driver-performance" element={<DriverPerformance />} />
        <Route path="/reporting/timing" element={<Timing />} />
        <Route path="/reporting/milestone-location" element={<MilestoneDistance />} />
        <Route path="/reporting/customer-feedback" element={<CustomerFeedback />} />
        <Route path="/reporting/dpd" element={<DpdHandoffs />} />
        <Route path="/cost/delivery" element={<DeliveryCost />} />
        <Route path="/team/users" element={<Users />} />
        <Route path="/invite" element={<InviteUser />} />
        {/* Legacy path → overview */}
        <Route path="/dashboard" element={<Navigate to="/reporting/overview" replace />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
